import React from "react";
import classNames from "classnames";

/**
 * CardGrid displays a grid of card components, applying styling to ensure
 * that each card is equal width and height.
 * Note: the child components of CardGrid must accept a `className` prop.
 */
export const CardGrid: React.FC<{
  className: string;
  children?: React.ReactNode;
}> = ({ children, className }) => (
  <div className={classNames(className, "row flex flex-wrap")}>
    {React.Children.map(children, (element) => {
      if (React.isValidElement(element)) {
        return (
          <div className="col-1/2 md:col-1/3 lg:col-1/4 mb-md flex">
            {React.cloneElement(element, {
              className: classNames(element.props.className, "w-full"),
            })}
          </div>
        );
      } else {
        return null;
      }
    })}
  </div>
);
